import React, { FunctionComponent } from 'react'
import { observer } from 'mobx-react'

export interface RowHeaderProps {
  onStickyClick?: () => void
  isSticky: boolean
  isStuck: boolean
  isOriginHeader?: boolean // Is Column & Row header (top left origin)
  children?: any
  sortField?: string
  sortDir?: 'asc'|'desc'
  width: number
}

export const RowHeader: FunctionComponent<RowHeaderProps> = observer(({
  onStickyClick,
  isSticky,
  isStuck,
  isOriginHeader,
  children,
  width
}) => {
  return (
    <div 
      className={`row_header sch_cell is_sticky ${isStuck ? 'is_stuck is_stuck_left' : ''}`}
      style={{
        width: width
      }}
    >
      <div className={`row_header_contents`}>
        {!isOriginHeader && onStickyClick &&
          <button 
            type="button"
            className={`btn btn-icon icon-pushpin ${isSticky ? "is_active" : ""}`}
            onClick={onStickyClick}
            data-tooltip={`${isSticky ? 'Unstick' : 'Stick'} Row to view`}
          />
        }
        {children}
      </div>
    </div>
  )
})